import(/* webpackMode: "eager" */ "/workspace/aregncapital/src/app/not-found.tsx");
